import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-event-messenger',
    templateUrl: './event-messenger.component.html',
    styleUrls: ['./event-messenger.component.scss']
})
export class EventMessengerComponent {

    @Input() data: any;

    infoText: string = 'Envía tus consultas o documentación a tu tramitador/a desde este espacio. Recibirás respuesta en un plazo máximo de 24 horas';

}
